import { FC, useEffect } from 'react';
import { AplautReviewsBlockTypeProps } from './TypeProps';
import { AplautReviews } from '@features/aplautReviews';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { ElementIdTab, getCountReviews, getProductRN } from '@entities/Product';
import classNames from 'classnames';

import styles from './AplautReviewsBlock.module.scss';

export const AplautReviewsBlock: FC<AplautReviewsBlockTypeProps> = ({ className }) => {
  const productRN = useAppSelector(getProductRN);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getCountReviews({ productRN }));
  }, [productRN]);
  return (
    <div id={ElementIdTab.TabReviews} className={classNames(styles.WrapperAplautReviewsBlock, className)}>
      <AplautReviews productRN={productRN} elementId={'reviews'} />
    </div>
  );
};
